import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "textarea", "status"]
  static values = { url: String }

  connect() {
    console.log("DescriptionGeneratorController connected")
  }

  async generate(event) {
    event.preventDefault()

    if (!this.urlValue) {
      console.error("No URL configured for description generation")
      return
    }

    // Update UI to show loading state
    this.buttonTarget.disabled = true
    this.buttonTarget.innerHTML = `
      <svg class="animate-spin w-3.5 h-3.5 mr-1" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      Generating...
    `
    this.statusTarget.classList.remove("hidden")
    this.statusTarget.textContent = "Analyzing project meetings and materials..."
    this.statusTarget.classList.remove("text-red-500")
    this.statusTarget.classList.add("text-slate-500")

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
        }
      })

      const data = await response.json()

      if (data.success) {
        // Update the textarea with the generated description
        this.textareaTarget.value = data.description
        this.statusTarget.textContent = `Generated! (${data.tokens_used} tokens used)`
        this.statusTarget.classList.remove("text-red-500")
        this.statusTarget.classList.add("text-green-600")
      } else {
        this.statusTarget.textContent = data.error || "Failed to generate description"
        this.statusTarget.classList.remove("text-slate-500", "text-green-600")
        this.statusTarget.classList.add("text-red-500")
      }
    } catch (error) {
      console.error("Description generation error:", error)
      this.statusTarget.textContent = "Error generating description. Please try again."
      this.statusTarget.classList.remove("text-slate-500", "text-green-600")
      this.statusTarget.classList.add("text-red-500")
    } finally {
      // Restore button state
      this.buttonTarget.disabled = false
      this.buttonTarget.innerHTML = `
        <svg class="w-3.5 h-3.5 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z"/>
        </svg>
        Generate with AI
      `
    }
  }
}

